import { UserProfileType } from "@/graphql/types";
import { ref, readonly } from "vue";
import { isValidGuid } from "./utils";

interface WithHomePage {
  userHomePage: string;
}

const user = ref<(UserProfileType & WithHomePage) | undefined>();

export default function () {
  function setUser(profileType: UserProfileType | undefined) {
    let selectedDefaultpage = "/claims";

    if (profileType && isValidGuid(profileType.userId)) {
      selectedDefaultpage = profileType.isSuperAdmin
        ? "/"
        : profileType.isAdmin
        ? `/organizations/${profileType.organizationId}`
        : profileType.isApplicationAdmin
        ? `/applications`
        : profileType.isUserAdmin
        ? `/users`
        : "/me";
    }

    user.value = profileType
      ? {
          ...profileType,
          userHomePage: selectedDefaultpage,
        }
      : undefined;
  }

  return {
    user: readonly(user),
    setUser,
  };
}
